export enum AppRoutingPathsEnum {
  Desktop = 'desktop',
}
